import ListItem from '@material-ui/core/ListItem';
import { withStyles } from '@material-ui/core/styles';

const DrawerListItem = withStyles(() => ({
  gutters: {
    padding: '0px 8px',
  },
}))(ListItem);

export default DrawerListItem;
